import { useState } from 'react';
import { formatAmount } from '../helpers/currency.helper';
import { CURRENCY, FORMAT_TYPE } from '../constants/general';
import { SORT_TYPES } from '../flows/transactions/constants';

export const useSortableTable = (data: any) => {
  const [sortingIndex, setSortingIndex] = useState(0);
  const [sortField, setSortField] = useState('');
  const [order, setOrder] = useState('asc');

  const handleSorting = (filedToSort: any, index: any) => {
    let currentOrder;
    if (sortField !== filedToSort.value && sortField) {
      currentOrder = 'asc';
      setOrder('asc');
    } else {
      currentOrder = order === 'asc' ? 'desc' : 'asc';
      setOrder(order === 'asc' ? 'desc' : 'asc');
    }
    const foramttedValue = filedToSort.value.toString();
    const sortedRows: any = (filedToSort.sortType === SORT_TYPES.ALPHABETICAL)
      ? data.sort((a: any, b: any) => ((a[foramttedValue].toLowerCase() < b[foramttedValue].toLowerCase()) ? -1 : ((b[foramttedValue].toLowerCase() > a[foramttedValue].toLowerCase()) ? 1 : 0)))
      : (filedToSort.sortType === SORT_TYPES.NUMERICAL)
        ? data.sort((a: any, b: any) => formatAmount(b[foramttedValue], FORMAT_TYPE.UNFORMATTED, CURRENCY.USD.SYMBOL, false) - formatAmount(a[foramttedValue], FORMAT_TYPE.UNFORMATTED, CURRENCY.USD.SYMBOL, false))
        : data.sort((a: any, b: any) => new Date(b[foramttedValue]).getTime() - new Date(a[foramttedValue]).getTime());
    setSortField(filedToSort.value);
    setSortingIndex(index);
    if (currentOrder === 'asc') data = sortedRows;
    if (currentOrder === 'desc') data = sortedRows.reverse();
  };
  return [handleSorting, sortingIndex, order];
};
